import axios from "axios";

export const fetchMarketplaceTherapists = async (params = {}) =>
  await axios.get(`${process.env.REACT_APP_SERVER_URI}/api/marketplace/therapists`, {
    params,
  });

export const fetchMarketplaceTherapistsAvailability = async (params = {}) =>
  await axios.get(`${process.env.REACT_APP_SERVER_URI}/api/marketplace/therapists/availability`, {
    params,
  });

export const fetchMarketplaceTherapistById = async (therapistId) =>
  await axios.get(
    `${process.env.REACT_APP_SERVER_URI}/api/marketplace/therapists/${therapistId}`
  );

export const fetchMarketplaceTherapistPaymentPlans = async (therapistId) =>
  await axios.get(
    `${process.env.REACT_APP_SERVER_URI}/api/marketplace/therapists/${therapistId}/payment-plans`
  );

export const fetchMarketplaceTherapistSlots = async (therapistId, params = {}) =>
  await axios.get(
    `${process.env.REACT_APP_SERVER_URI}/api/marketplace/therapists/${therapistId}/slots`,
    {
      params,
    }
  );
